import logo from '../../assets/images/logo.png';
import { Layout } from 'antd';
import React from 'react';
import { MainLayoutStyle } from './MainLayout.jss';
import UserInfo from '../../components/UserInfo/UserInfo';
import { Col, Row } from 'antd';
import { WithChildrenProps } from '../../types/generalTypes';
const { Header, Content } = Layout;

const MainLayout: React.FC<WithChildrenProps> = ({ children }) => {
    const style = MainLayoutStyle();

    return (
        <Layout>
            <Header className={style.headerStyle}>
                <Row>
                    <Col lg={6} md={6} sm={6}>
                        <img className={style.logoStyle} src={logo} alt="National Netherlands Logo" />
                    </Col>
                    <Col lg={18} md={18} sm={18}>
                        <UserInfo />
                    </Col>
                </Row>
            </Header>
            <Content className={style.contentStyle}>
                <div className={style.containerStyle}>
                    <>{children}</>
                </div>
            </Content>
        </Layout>
    );
};

export default MainLayout;
